import { onMounted, ref, watch } from 'vue';
import { debounce } from 'lodash';

type FlowCustomConditionEntry = {
  predicate: string;
  values: string[];
};

type FlowConditions = Record<string, FlowCustomConditionEntry>;

export const useFlowCustomCondition = (
  conditions: FlowConditions,
  conditionName: string,
) => {
  const predicate = ref('EQUALS');
  const includeUnknown = ref(false);
  const textAreaValue = ref('');

  const updateCondition = () => {
    if (textAreaValue.value) {
      if (!conditions[conditionName]) {
        conditions[conditionName] = {
          predicate: predicate.value,
          values: [''],
        };
      }

      const result = textAreaValue.value.split('\n').filter((value) => !!value);
      if (includeUnknown.value) {
        result.push('');
      }

      conditions[conditionName].values = result;
    } else {
      conditions[conditionName].values = [''];
    }
  };

  const updateConditionDebounced = debounce(updateCondition, 100);

  watch(predicate, (value) => {
    conditions[conditionName].predicate = value;
  });

  watch(textAreaValue, () => {
    updateConditionDebounced();
  });

  watch(includeUnknown, () => {
    updateConditionDebounced();
  });

  onMounted(() => {
    if (conditions[conditionName]) {
      const empty = conditions[conditionName].values.find((value) => value === '');
      if (empty === '') {
        includeUnknown.value = true;
      }

      textAreaValue.value = conditions[conditionName].values
        ? conditions[conditionName].values.filter((value) => !!value).join('\n')
        : '';
      predicate.value = conditions[conditionName].predicate || predicate.value;
    } else {
      conditions[conditionName] = {
        predicate: predicate.value,
        values: [''],
      };
    }
  });

  return {
    predicate,
    includeUnknown,
    textAreaValue,
  };
};
